import * as React from "react";

import * as Yup from "yup";
import { Formik } from "formik";
import { useRouter } from "next/router";
import Cookies from "universal-cookie";
import { Grid, makeStyles } from "@material-ui/core";
import { toast } from "react-toastify";

import SelectSupportValueCurrency from "./selectSupportValueCurrency";
import { postApiService } from "../../../../services/AgapeAPI";
import RoundButton from "../../../../components/common/button/RoundButton";
import { AgapeTextField } from "../../../../components/common/typography";
import { emailRegex } from "../../../../helpers/validators";
import AgapeIcon from "../../../common/icons/AgapeIcon";
import SimpleTextField from "../../../common/textfield/SimpleTextField";
import useError from "../../../../helpers/useError";

const cookies = new Cookies();

const useStyles = makeStyles((theme) => ({
  Bg: {
    width: "95%",
    margin: "20px auto",
    height: "100vh",
  },
  BgForm: {
    width: "100%",
    marginTop: "40px",
  },
  Title: {
    marginBottom: "30px",
    fontSize: "2rem",
  },
  title: {
    fontSize: "1.5rem",
  },
  star: {
    color: "red",
  },
  fild: {
    textAlign: "left",
    direction: "rtl",
    marginBottom: "15px",
    "& .MuiInputBase-root": {
      // fontFamily: 'Vazir-Bold !important',
      fontFamily: "sans-serif !important",
    },
  },
  Btn: {
    width: "100%",
    margin: "50px 0",
  },
  submit: {
    display: "flex",
    justifyContent: "center",
    borderRadius: "10px",
    width: "200px",
    marginTop: "40px",
  },
  cancel: {
    width: "95%",
    borderRadius: "10px",
    backgroundColor: "#fff",
    color: "#888",
    border: "1px solid #888",
    "&:hover": { backgroundColor: "#888", color: "#fff" },
  },
  err: {
    display: "flex",
    width: "100%",
    justifyContent: "right",
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: "red",
  },
  supportValueContainer: {
    marginTop: "30px",
    marginBottom: "30px",
  },
}));
const DEFAULT_VALUES = [5, 20, 50, 100, 200, 500];

const Schema = Yup.object().shape({
  Mobile: Yup.string()
    .matches(
      "^[(00)|(+)]{1}[0-9\\s.\\/-]{11,20}$",
      "Mobile Number Is Not Valid"
    )
    .required("Please Fill The Input"),
  Email: Yup.string()
    .matches(emailRegex, "Email Address Is Not Valid")
    .required("Please Fill The Input"),
  FirstName: Yup.string().required("Please Fill The Input"),
  LastName: Yup.string().required("Please Fill The Input"),
  Address: Yup.string()
    .matches(
      /^[0-9a-zA-Z.-\s'"/,()`~]+$/,
      "The Address Should Look Like This: 607ChurchLCLEVELANDTS842TD"
    )
    .required("Please Fill The Input"),
  City: Yup.string().required("Please Fill The Input"),
  Country: Yup.string().required("Please Fill The Input"),
  PostalCode: Yup.string().required("Please Fill The Input"),
});

const CurrencyPayment = (props) => {
  const isLogin = cookies.get("isLoggedIn") === "1";

  const errorHook = useError();
  const setError = (err) => errorHook(err);

  const router = useRouter();
  const { id, type } = router.query;
  const [Amount, setAmount] = React.useState(5);
  const [OrgId, setOrgId] = React.useState();
  const [activeTab, setActiveTab] = React.useState(0);
  const [forClient, setForClient] = React.useState(false);

  const localData =
    typeof window !== "undefined" &&
    JSON.parse(localStorage.getItem("payment_methods_data"));

  const handleTabChanged = (index) => {
    setActiveTab(index);
    setAmount(DEFAULT_VALUES[index]);
  };

  React.useEffect(() => {
    if (id) {
      setOrgId(id);
    } else {
      setOrgId(217);
    }
  }, []);

  const classes = useStyles();
  const customLangValidation = (val, func) => {
    const arregex = /^[| آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ\s* ]+$/;
    if (!arregex.test(val.target.value)) {
      func(val);
    }
  };

  const handleAmount = (e) => {
    const arregex = /^(|[1-9]\d*)$/;
    if (arregex.test(e)) {
      setAmount(e);
    }
  };

  React.useEffect(() => {
    setForClient(true);
    if (localData) {
      if (localData.organization_id) {
        setOrgId(localData.organization_id);
      }
      if (localData.amount) {
        setAmount(localData.amount);
      }
    }
  }, []);

  return (
    <Grid className={classes.Bg} container spacing="2">
      <Grid item xs="12">
        {forClient && (
          <Formik
            initialValues={{
              FirstName: localData?.FirstName,
              LastName: localData?.LastName,
              Email: localData?.Email,
              Mobile: localData?.Mobile,
              Address: localData?.Address,
              City: localData?.City,
              Country: localData?.Country,
              PostalCode: localData?.PostalCode,
            }}
            onSubmit={(values) => {
              if (isLogin || !props.data?.require_login) {
                localStorage.removeItem("payment_methods_data");
                const ROOT =
                  type && type === "oxygen"
                    ? "pay/oxygen-campaign"
                    : "pay/dedicate-payments";
                const data = {
                  amount: Amount,
                  mobile: values.Mobile,
                  organization_id: OrgId,
                  via: "yekpay",
                  email: values.Email,
                  firstName: values.FirstName,
                  lastName: values.LastName,
                  address: values.Address,
                  postalCode: values.PostalCode,
                  country: values.Country,
                  city: values.City,
                };
                postApiService(ROOT, data)
                  .then((res) => {
                    // window.location.href = res.data;
                    window.open(res.data, "_self");
                  })
                  .catch((ex) => {
                    if (ex.response.status === 403) {
                      localStorage.setItem(
                        "payment_methods_data",
                        JSON.stringify({ ...data, ROOT })
                      );

                      localStorage.setItem(
                        "failed_payment_for_auth",
                        JSON.stringify({
                          url: ROOT,
                          data,
                        })
                      );
                      router.replace(`/login?from=${router.asPath}`);
                    } else {
                      setError(ex);
                    }
                  });
              } else {
                const ROOT =
                  type && type === "oxygen"
                    ? "pay/oxygen-campaign"
                    : "pay/dedicate-payments";

                const data = {
                  amount: Amount,
                  mobile: values.Mobile,
                  organization_id: OrgId,
                  via: "yekpay",
                  email: values.Email,
                  firstName: values.FirstName,
                  lastName: values.LastName,
                  address: values.Address,
                  postalCode: values.PostalCode,
                  country: values.Country,
                  city: values.City,
                };

                localStorage.setItem(
                  "payment_methods_data",
                  JSON.stringify({
                    ROOT,
                    ...data,
                  })
                );

                localStorage.setItem(
                  "failed_payment_for_auth",
                  JSON.stringify({
                    url: ROOT,
                    data,
                  })
                );
                router.replace(`/login?from=${router.asPath}`);
              }
            }}
            validationSchema={Schema}
          >
            {({
              values,
              errors,
              isSubmitting,
              isValid,
              handleSubmit,
              handleChange,
              handleBlur,
              handleReset,
              setFieldValue,
            }) => (
              <form className={classes.BgForm}>
                <Grid item md={12}>
                  <Grid container item md={12} className={classes.padding}>
                    <Grid item md={6}>
                      <SimpleTextField
                        required
                        name="Amount"
                        value={Amount}
                        error={!Amount}
                        onChange={(e) => {
                          handleAmount(e.target.value);
                        }}
                        EndAdornment={
                          <AgapeIcon
                            icon="logo-euro"
                            size="20px"
                            color="rgba(21, 52, 42, 0.72)"
                          />
                        }
                        inputProps={{
                          maxLength: 15,
                        }}
                        customClassName={classes.paymentField}
                      />
                    </Grid>
                  </Grid>

                  <Grid item md={12} className={classes.supportValueContainer}>
                    <SelectSupportValueCurrency
                      activeTab={activeTab}
                      handleTabChanged={handleTabChanged}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing="2">
                  <Grid item xs="6">
                    <AgapeTextField
                      LastName
                      required
                      name="LastName"
                      value={values.LastName}
                      onChange={(e) => {
                        customLangValidation(e, handleChange);
                      }}
                      classNameCustom={classes.fild}
                      fullWidth
                      variant="outlined"
                      placeholder="Last name"
                    />
                  </Grid>
                  <Grid item xs="6">
                    <AgapeTextField
                      FirstName
                      required
                      name="FirstName"
                      value={values.FirstName}
                      onChange={(e) => {
                        customLangValidation(e, handleChange);
                      }}
                      classNameCustom={classes.fild}
                      fullWidth
                      variant="outlined"
                      placeholder="First name "
                    />
                  </Grid>
                </Grid>

                <Grid container spacing="2">
                  <Grid item xs="6">
                    <AgapeTextField
                      email
                      required
                      name="Email"
                      value={values.Email}
                      error={errors.Email}
                      onChange={(e) => {
                        customLangValidation(e, handleChange);
                      }}
                      // onBlur={handleBlur}
                      classNameCustom={classes.fild}
                      fullWidth
                      variant="outlined"
                      placeholder="EX:email@email.com"
                    />
                    <span className={classes.err}>{errors.Email}</span>
                  </Grid>
                  <Grid item xs="6">
                    <AgapeTextField
                      email
                      required
                      name="Mobile"
                      error={errors.Mobile}
                      value={values.Mobile}
                      onChange={(e) => {
                        customLangValidation(e, handleChange);
                      }}
                      classNameCustom={classes.fild}
                      fullWidth
                      variant="outlined"
                      placeholder="EX:+989123456789"
                    />
                    <span className={classes.err}>{errors.Mobile}</span>
                  </Grid>
                </Grid>

                <Grid container spacing="1">
                  <Grid item xs="12">
                    <AgapeTextField
                      email
                      required
                      name="Address"
                      value={values.Address}
                      onChange={(e) => {
                        customLangValidation(e, handleChange);
                      }}
                      classNameCustom={classes.fild}
                      fullWidth
                      variant="outlined"
                      placeholder="Address"
                    />
                    <span className={classes.err}>{errors.Address}</span>
                  </Grid>
                </Grid>
                <Grid container spacing="3">
                  <Grid item xs="4">
                    <AgapeTextField
                      email
                      required
                      name="City"
                      value={values.City}
                      onChange={(e) => {
                        customLangValidation(e, handleChange);
                      }}
                      classNameCustom={classes.fild}
                      fullWidth
                      variant="outlined"
                      placeholder="City"
                    />
                  </Grid>
                  <Grid item xs="4">
                    <AgapeTextField
                      email
                      required
                      name="Country"
                      value={values.Country}
                      onChange={(e) => {
                        customLangValidation(e, handleChange);
                      }}
                      classNameCustom={classes.fild}
                      fullWidth
                      variant="outlined"
                      placeholder="Country"
                    />
                  </Grid>
                  <Grid item xs="4">
                    <AgapeTextField
                      email
                      required
                      name="PostalCode"
                      value={values.PostalCode}
                      onChange={(e) => {
                        customLangValidation(e, handleChange);
                      }}
                      classNameCustom={classes.fild}
                      fullWidth
                      variant="outlined"
                      placeholder="Postal code"
                    />
                  </Grid>
                </Grid>
                <Grid container space="4" className={classes.Btn}>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <RoundButton
                      disabled={
                        Number(Amount) < 4 ||
                        errors.FirstName ||
                        errors.LastName ||
                        errors.Email ||
                        errors.Mobile ||
                        errors.Address ||
                        errors.City ||
                        errors.Country ||
                        errors.PostalCode ||
                        !values.Address
                      }
                      // type="submit"
                      onClick={handleSubmit}
                      customClassName={classes.submit}
                    >
                      Submit
                    </RoundButton>
                  </div>
                </Grid>
              </form>
            )}
          </Formik>
        )}
      </Grid>
    </Grid>
  );
};

export default CurrencyPayment;
